import { palette } from '../palette';

export function contrast(contrastBold: boolean, mode: 'light' | 'dark') {
  const theme = {
    ...(contrastBold &&
      mode === 'light' && {
        palette: {
          background: {
            default: palette(mode).grey[200],
          },
        },
      }),
  };

  // @Saman: this overrides the customized themes we've done for these components, so I'm commenting them out for now [Maziar]
  const components = {
    ...(contrastBold &&
      {
        // MuiCard: {
        //   styleOverrides: {
        //     root: {
        //       boxShadow: customShadows(mode).z4,
        //     },
        //   },
        // },
      }),
  };

  return {
    theme,
    components,
  };
}
